import React from 'react';
import { EntryCollection } from 'contentful';
import {
	ITypeHelpDrawerFields,
	ITypeOneCartCountriesFields,
	ITypeRichTextFields,
	TypeLandEnumValues,
	countrySupplierMapByLandId,
} from '@adac-mp/shared';
import { Hint, Richtext } from '../../index';

const getHintContentData = (hintMessageContent: any, fallBack: Hint[], onClick?: () => void, replaceText?: string) => {
	return hintMessageContent?.message
		? [
				{
					tip: hintMessageContent?.tip,
					message: hintMessageContent?.message ? (
						<Richtext document={hintMessageContent.message} replaceText={replaceText} />
					) : (
						''
					),
					link: hintMessageContent?.linkText
						? {
								text: hintMessageContent?.linkText,
								onClick,
						  }
						: undefined,
				},
		  ]
		: fallBack;
};

export const checkHintContent = (id: string, hintMessages?: any) =>
	hintMessages?.items.find((hintMessage: any) => hintMessage.id === id);

export const getHintContent = (
	id: string,
	fallBack: Hint[],
	hintMessages?: any,
	onClick?: () => void,
	replaceText?: string,
) => {
	const hintMessageContent = hintMessages?.items.find((hintMessage: any) => hintMessage.id === id);
	const hintMessageContentData = getHintContentData(hintMessageContent, fallBack, onClick, replaceText);
	return hintMessageContentData ?? fallBack;
};

export const getDrawerTitle = (id: string, drawers?: any) => {
	const drawerContent = drawers?.items.find((drawer: any) => drawer.id === id);
	return drawerContent?.helpDrawerTitle;
};

export interface IHelperDrawerContent {
	id: string;
	title: string;
}

export const getDrawerHelperData = (stepDrawerId: string, helpDrawers) => {
	return {
		id: stepDrawerId,
		title: getDrawerTitle(stepDrawerId, helpDrawers),
	};
};

export interface IOneCartCountry {
	countryId: TypeLandEnumValues;
	country: string;
	description: ITypeRichTextFields;
}

export const getOneCartCountries = (oneCartCountryItems: any): IOneCartCountry[] | undefined =>
	oneCartCountryItems?.map(({ id, country, description }) => ({
		countryId: id.landList,
		country,
		description,
	}));

export const getCountryName = (supplierId: number, countries?: any) => {
	return countries?.items.find(
		({ id }: ITypeOneCartCountriesFields) => countrySupplierMapByLandId[id.landList] === supplierId,
	)?.country;
};

export const getCorrespondingHelpDrawerContent = (
	supplierId: number,
	helpDrawers: EntryCollection<ITypeHelpDrawerFields> | undefined,
) => {
	switch (supplierId) {
		case 3:
			return {
				id: 'productSelection',
				title: getDrawerTitle('productSelection', helpDrawers),
			};
		case 7:
			return {
				id: 'productSelectionSlovenia',
				title: getDrawerTitle('productSelectionSlovenia', helpDrawers),
			};
		case 14:
			return {
				id: 'productSelectionSchweiz',
				title: getDrawerTitle('productSelectionSchweiz', helpDrawers),
			};
		default:
			return {
				id: 'productSelection',
				title: getDrawerTitle('productSelection', helpDrawers),
			};
	}
};
